import { AnalyticsContext, MemberEvent, trackEvent } from "#app/lib/analytics";

/** A `DetailFieldRow` `onContact` that sends `member.contact` for one field. */
export const memberContact =
  (field: "email" | "phone" | "username", via: "profile" | "preview") =>
  (action: "email" | "call" | "open" | "copy") =>
    trackEvent({
      context: AnalyticsContext.Member,
      event: MemberEvent.Contact,
      data: { field, action, via },
    });
